export const ProductAd = {
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'Product Ad',
    },
    PromotionalText: {
      'bulk-upload-header': 'Promotion',
    },
    CampaignName: {
      'bulk-upload-header': 'Campaign',
    },
    AdGroupName: {
      'bulk-upload-header': 'Ad Group',
    },
  },
};
